import { NavLink } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
import { Stack, Typography } from '@mui/material';
import { NavListProps } from 'src/components/nav-section';

// ----------------------------------------------------------------------

const RootStyle = styled(Stack)(({ theme }) => ({
  '& a': {
    color: theme.palette.text.primary,
    padding: theme.spacing(1.5, 0.5),
    textDecoration: 'none',
  },
  '& .active': {
    color: theme.palette.primary.main,
    '& svg > *': {
      fill: theme.palette.primary.main,
    },
    borderBottom: `3px solid ${theme.palette.primary.main}`,
  },
}));

// ----------------------------------------------------------------------

const NavbarHorizontalV2: React.FC<{ menuItems: NavListProps[] }> = ({ menuItems }) => {
  return (
    <RootStyle direction={'row'} flexWrap={'wrap'} alignItems={'center'} spacing={2}>
      {menuItems?.map((el: any) => {
        return (
          <NavLink
            key={el.id}
            to={el?.path}
            className={({ isActive }) => (isActive ? 'active' : 'inactive')}
          >
            <Stack spacing={1} direction={'row'}>
              {el?.icon}
              {el?.title && <Typography>{el?.title}</Typography>}
            </Stack>
          </NavLink>
        );
      })}
    </RootStyle>
  );
};

export default NavbarHorizontalV2;
